export const styles = {
        container: {
            background: '#F7F8FA',
            padding: '30px',
        },
        panel: {
            background: '#FFFFFF',
            border: '1px solid #0000001A',
            borderRadius: '4px',
            height: '100%',
            padding: '30px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
        },
        iconButton: {
            borderRadius: '4px',
            font: 'normal normal normal 14px / 21px Segoe UI',
            color: "#22638D",
            '&:hover': {
                backgroundColor: "#F4F7F9",
            },
        },
        headerText: {
            display: 'flex',
            alignItems: 'center',
            font: 'normal normal 600 20px/ 27px Segoe UI',
        },
        saveButton: {
            height: '36px',
            backgroundColor: '#22638D',
            textTransform: 'none',
            font: 'normal normal normal 14px/21px Segoe UI',
            whiteSpace: 'nowrap',
        },
        cancelButton: {
            height: '36px',
            textTransform: 'none',
            font: 'normal normal normal 14px/21px Segoe UI',
            whiteSpace: 'nowrap',
        },
        sectionTitle: {
            font: 'normal normal 600 16px/ 24px Segoe UI',
        },
        label: {
            font: 'normal normal normal 12px / 18px Segoe UI',

        },
        textField: {
            width: '100%',
            borderBottom: '1px solid black',

            '&.MuiTextField-root': {
                border: 'none',
            },
        },
        description: {
            font: 'normal normal normal 14px / 21px Segoe UI',
            opacity: 0.7,
        },
        switch: {
            '& .MuiSwitch-switchBase': {
                color: '#969696',
                '&.Mui-checked': {
                    color: '#22638D',
                },
            },
            '& .MuiSwitch-track': {
                backgroundColor: '#BDBDBD',
            },
        },
        twoFaText: {
            font: 'normal normal normal 14px / 21px Segoe UI',
            opacity: 0.5,
        },
    };